module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/6th/mainvisual-date-sp@2x_1acdb875b1543a8aad134aaa90f676fb.png";